
const iconMetadata = [
    {
        title: 'Logo',
        body: [
            {
                type: "png",
                content: "logo.png"
            },
            {
                type: "copyright",
                content: "© 2022 Moonbit Labs, S.A. de C.V. All Rights Reserved"
            }
        ]
    },
    {
        title: 'About',
        body: [
            {
                type: 'text',
                content: "Moonbit Labs is a company specialized in the development of Web3 projects"
            },
            {
                type: 'text',
                content: "We are a group of enthusiasts and believers in the crypto universe that seek to advise and create onramps for people, businesses and brands into the blockchain."
            },
            {
                type: 'text',
                content: "We are a full service shop that handles the development, marketing, creative and legal requirements to build out a successful web3 project."
            },
            {
                type: 'text',
                content: "Dive in, the water's warm."
            },
            {
                type: 'text',
                content: "Have a question? Chat with us at hello@moonbitlabs.xyz"
            }
        ]
    },
    {
        title: 'Founding Team',
        body: [
            {
                type: 'text',
                content: "Joachim - Project Manager"
            },
            {
                type: 'twitter',
                content: "@xWEBWEBWEB"
            },
            {
                type: 'text',
                content: "ManOnTheMoon - Marketing Director"
            },
            {
                type: 'twitter',
                content: "@Manonthemoon069"
            },
            {
                type: 'text',
                content: "DuckInTheBlock - Legal Director"
            },
            {
                type: 'twitter',
                content: "@DuckInTheBlock"
            },
            {
                type: 'text',
                content: "Chainbum - Developer"
            },
            {
                type: 'twitter',
                content: "@_chainbum_"
            },
            {
                type: 'text',
                content: "Mr. ATOm - Creative Director"
            },
            {
                type: 'twitter',
                content: "@MrATOm_eth"
            },
        ]
    },
    {
        title: 'Services',
        body: [
            {
                type: 'text',
                content: "Advise and consulting for the integration of projects, brands and businesses to Blockchain technology"
            },
            {
                type: 'text',
                content: "Implementation of Smart Contracts, including Non-Fungible Tokens (NFTs) and Fungible Tokens"
            },
            {
                type: 'text',
                content: "Community management, marketing and branding tailored to web3"
            },
            {
                type: 'text',
                content: "Training in cyber security"
            },
            {
                type: 'text',
                content: "Crypto-asset investment management including, among others, decentralized finance (DeFi), mining, trading and staking."
            },
            {
                type: 'text',
                content: "Interested? Chat with us at:"
            },
            {
                type: 'email',
                content: "hello@moonbitlabs.xyz"
            }
        ]
    },
    {
        title: 'Contact Us',
        body: [
            {
                type: 'text',
                content: "Twitter"
            },
            {
                type: 'twitter',
                content: "@moonbitlabs"
            },
            {
                type: 'text',
                content: "Email"
            },
            {
                type: 'email',
                content: "hello@moonbitlabs.xyz"
            }
        ]
    },
    {
        title: 'Projects',
        body: [
            {
                type: 'text',
                content: "WebTimeFolks"
            },
            {
                type: 'twitter',
                content: "@WebTimeFolks"
            }
        ]
    },
    {
        title: 'Legal',
        body: [
            {
                type: 'icon',
                content: "Terms and Conditions"
            },
            {
                type: 'icon',
                content: "Privacy Policy"
            }
        ]
    },
    {
        title: 'Terms and Conditions',
        body: [
            {
                type: 'text',
                content: "Last update: April 2022"
            },
            {
                type: 'text',
                content: "Please read these Terms & Conditions of Use (“Terms”) and our Private Policy (“Private Policy”) carefully. They shall govern your use of the site https://moonbitlabs.xyz, the content and the functionality accessible (collectively “Site”), offered by Moonbit Labs, S.A. de C.V. (“Moonbit Labs”)."
            },
            {
                type: 'text',
                content: "Notice Regarding Arbitration: When you agree these Terms you are agreeing (with limited exception) to resolve any dispute between you and Moonbit Labs through Binding, Individual arbitration rather than in Court. If you are a resident of a jurisdiction here applicable law prohibits arbitration of disputes, the agreement to arbitration on section 14 of these Terms will not apply, but the provisions of section 13 will apply instead."
            },
            {
                type: 'text',
                content: "Section 1. Agreement to Terms. By using the Site, you agree to be bound by these Terms. If you don't agree, don't use the Site."
            },
            {
                type: 'text',
                content: "Section 2. Privacy Policy. Review our Private Policy, which also governs the use of this Site, where you will find the information on how we collect, use, and share your information."
            },
            {
                type: 'text',
                content: "Section 3. Changes to these Terms and/or this Site. We may update these Terms from time to time at Moonbit Lab's whole discretion. If we do, we'll let you know by posting the updated terms on the Site. We find important that you review these Terms whenever we update them or whenever you use the Site. If you continue to use the Site after we have posted updated Terms, it means you accept and agree to be bound with them. If you don't, you may not use the Site anymore. We may change or discontinue all or part of the Site, at any time without notice, at our whole discretion."
            },
            {
                type: 'text',
                content: "Section 4. Who may use the Site? You may use it only if you are 18 years or older, and capable of forming a binding contract with Moonbit Labs, and not otherwise barred from using the Site under applicable law."
            },
            {
                type: 'text',
                content: "Section 5. Feedback & Unsolicited Material. We welcome and value your feedback on the Site, but please don't send unsolicited material (“Unsolicited Material”). These Terms are aimed at avoiding potential disputes, misuses and/or misunderstandings when our Site might seem similar to Unsolicited Material that people submit. We may currently be developing, have developed or will develop in the future ideas or materials internally or receive materials or ideas from other parties that may be similar to Unsolicited Material. If you ignore these Terms and send us your Unsolicited Material anyway, you grant us a non-exclusive, worldwide, perpetual, irrevocable, commercial, fully-paid, royalties-free, sub-licensable, non-personal, and transferable License under any and all intellectual property rights (“IP”) or other rights that you own or control to use, copy, modify, create derivative works based upon, make, have made, sell, offer for sale, register, distribute, import and otherwise exploit in any manner or medium whatsoever known now or in the future your Unsolicited Material for any purpose, without compensation to you."
            },
            {
                type: 'text',
                content: "Section 6. Moonbit Labs' IP. We may make available through the Site, content that is subject to IP rights. We or our licensors, or any other third party who otherwise owns the IP rights, retain all rights to that content."
            },
            {
                type: 'text',
                content: "Section 7. General Prohibitions & Moonbit Labs' Enforcement Rights. You agree not to do any of the following:"
            },
            {
                type: 'text',
                content: "7.1. Use, display, mirror or frame the Site or any individual element within the Site; Site's name; any Moonbit Labs' trademark, logo or any other IP right; the layout and design of any page or form contained on a page, without Moonbit Labs' express written consent;"
            },
            {
                type: 'text',
                content: "7.2. Access, tamper with, or use non-public areas of the Site, Moonbit Labs' computer systems, or the technical delivery systems of Moonbit Labs' providers or any other APIs;"
            },
            {
                type: 'text',
                content: "7.3. Attempt to probe, scan or test the vulnerability of any of Moonbit Labs' systems or networks, or breach any security or authentication measures;"
            },
            {
                type: 'text',
                content: "7.4. Avoid, bypass, remove, deactivate, impair, descramble, or otherwise circumvent any technological measure implemented by Moonbit Labs or any of Moonbit Labs' providers or any other third parties (including another user) to protect the Site;"
            },
            {
                type: 'text',
                content: "7.5. Attempt to access or search the Site or download content from the Site using any engine, software, tool, agent, device or mechanism (including spiders, robots, crawlers, data mining tool or any alike tool) other than the software and/or search agents provided by Moonbit Labs or other generally available third-party web browsers;"
            },
            {
                type: 'text',
                content: "7.6. Use the Site, or any portion thereof, for any commercial purpose or for the benefit of any third party or in any manner not permitted by these Terms or without the written consent, when applicable;"
            },
            {
                type: 'text',
                content: "7.7. Attempt to decipher, decompile, disassemble or reverse engineer any of the software used to provide the services in the use of this Site;"
            },
            {
                type: 'text',
                content: "7.8. Interfere with or attempt to interfere with the access of any user, host or network, including, without any limitation, sending viruses, flooding, overloading, mail-bombing or spamming this Site;"
            },
            {
                type: 'text',
                content: "7.9. Impersonate or misrepresent your affiliation with any person or entity;"
            },
            {
                type: 'text',
                content: "7.10. Violate any applicable law or regulation; and/or"
            },
            {
                type: 'text',
                content: "7.11. Encourage or enable any other individual to do any of the foregoing."
            },
            {
                type: 'text',
                content: "Moonbit Labs is not bound to monitor the access to or use of the Site or to review or edit any content. However, we keep the right to do so for the purpose of operating the Site, to ensure the compliance of the users to these Terms and to be in compliance with the applicable law or any other legal requirements. We reserve the right, but are not obligated, to remove or disable any access to any content, at any time without consent or notice, including, but not limited to, if we, at our sole discretion, consider it objectionable or in violation of these Terms or conduct that affects this Site or any of our services or image. We may also consult and cooperate with law enforcement authorities to prosecute users who violate the law."
            },
            {
                type: 'text',
                content: "Section 8. Links to Third Parties Websites or Resources. The Site may allow you to access third parties' websites, services, APIs, or other resources. We provide access only as a convenience and are not responsible for the content, products, APIs, or services, on or available from those resources or links displayed on such websites. You acknowledge sole responsibility for and assume all risk arising for your use of any of the above-mentioned third-party resources."
            },
            {
                type: 'text',
                content: "Section 9. Termination. We may suspend or terminate your access and/or use of the Site, at our sole discretion, at any time and without any notice to you. Upon any termination, discontinuation or cancelation of these Terms or the Site, the following Sections will remain alive: 5, 6 and 8 through 15."
            },
            {
                type: 'text',
                content: "Section 10. Warranty Disclaimers. This Site is provided “as is” or “as it is”, without warranty of any kind. Without limiting the foregoing, we explicitly disclaim any implied warranties of merchantability, fitness for a particular purpose, quiet enjoyment and/or non infringement, and any warranties arising out of course of dealing or usage of trade. We make no warranty that the Site will meet your requirements and/or be available on an uninterrupted, secure, or error-free basis. We make no warranty regarding the quality, accuracy, timeliness, truthfulness, completeness or reliability of any information or content on the Site. Any reliance you place on such information or content is strictly at your own risk."
            },
            {
                type: 'text',
                content: "Section 11. Indemnity. You will indemnify and hold Moonbit Labs and its officers, directors, employees and/or agents, harmless from and against any claims, disputes, demands, liabilities, damages, losses, costs, and expenses, including, without limitation, reasonable legal and accounting fees arising out of or in any way related to: (a) your access to or the use of this Site; and/or (b) your violation of these Terms."
            },
            {
                type: 'text',
                content: "Section 12. Limitation of Liability."
            },
            {
                type: 'text',
                content: "12.1. To the maximum extent permitted by law, neither Moonbit Labs nor its service providers involved in creating, producing, or delivering this Site, will be liable for any special, consequential, incidental or exemplary damages or damages for lost profits, revenues, savings, business opportunities, data or goodwill, service interruption, computer damage or system failure or the cost of substitute services of any kind arising out of or in relation with these Terms of from the use of or inability to use the Site, whether based on warranty, contract, tort (including negligence), product liability or any other legal theory, and whether or not Moonbit Labs or its service providers have been informed of the possibility of such damage, even if a limited remedy set forth herein is found to have failed of its essential purpose."
            },
            {
                type: 'text',
                content: "12.2. To the maximum extent permitted by law, in no event will Moonbit Labs' total liability arising out or related to this Terms or from the use or inability to use the Site, will exceed one hundred USD ($100.00 USD)."
            },
            {
                type: 'text',
                content: "12.3. The exclusions and limitation of damages set forth above are fundamental elements of the basis of the agreement between Moonbit Labs and you."
            },
            {
                type: 'text',
                content: "Section 13. Governing Law and Forum Choice. These Terms, the use or inability to use the Site and any action related thereto will be governed by the Mexican Federal Law, applicable International Treaties and the laws of the State of Mexico City, without of its conflict of laws provisions. Except as otherwise expressly set in Section 14 of these Terms, the exclusive jurisdiction for all Disputes (defined bellow) that you and Moonbit Labs are not required to arbitrate will be the federal and state courts located in the State of Mexico City, and you and Moonbit Labs each waive any objection to jurisdiction and venue in such courts."
            },
            {
                type: 'text',
                content: "Section 14. Dispute Resolution."
            },
            {
                type: 'text',
                content: "14.1. Informal Resolution of Disputes. You and Moonbit Labs must first attempt to resolve any dispute, claim or controversy arising out of or relating to these Terms or the breach, termination, enforcement, interpretation, or validity thereof of the use or inability to use the Site (collectively, “Disputes”) informally. Accordingly, neither you nor Moonbit Labs may start a formal arbitration proceeding for at least 60 (sixty) days after one party notifies the other any claim in writing. As part of this informal resolution process, you must deliver your written notices via first-class mail to us at Moonbit Labs, Attn: Av. De las Fuentes 509, Jardines del Pedregal, Alvaro Obregon, 01900, Mexico City."
            },
            {
                type: 'text',
                content: "14.2. Mandatory Arbitration of Disputes. You and Moonbit Labs each agree that any Dispute will be resolved solely by binding, individual arbitration and not in a class, representative or consolidated action or proceeding. You and Moonbit Labs agree that the Mexican Federal Law governs the interpretation and enforcement of these Terms, and that you and Moonbit Labs are each waiving the right to a trial or to participate in a class action. This arbitration provision shall survive the termination of these Terms."
            },
            {
                type: 'text',
                content: "14.3. Exceptions. As limited exceptions to Section 14.2 above: (a) you and Moonbit Labs both seek to resolve a Dispute in small claims court, if it qualifies; (b) you and Moonbit Labs each retain the right to seek injunctive or other equitable relief from a Court to prevent (or enjoin) the infringement or misappropriation of our IP rights."
            },
            {
                type: 'text',
                content: "14.4. Arbitrator Authority. The arbitration will be conducted by the 'International Chamber of Commerce Mexico' (“ICC Mexico”), under its Arbitration Rules as of 2012, as amended in 2017. The start of any Arbitration proceeding can be found in https://www.iccmex.mx/comisiones-de-trabajo/servicios-de-arbitraje/servicios-de-arbitraje. Any arbitration hearings will take place in the country (or parish) where you live unless you and Moonbit Labs both agree to a different location. You and Moonbit Labs both agree that the arbitrator shall have exclusive authority to decide all issues relating to interpretation, applicability, enforceability, and scope of this arbitration agreement."
            },
            {
                type: 'text',
                content: "14.5. Arbitration Costs. Payment of all filing, administration and arbitrator fees will be governed by the ICC Mexico's rules and we won't seek to recover the administration and arbitration fees we are responsible of paying unless the arbitrator finds your Dispute frivolous. If we prevail in arbitration, we'll pay all our attorneys' fees and costs and won't seek to recover them from you. If you prevail in arbitration, you will be entitled to an award of attorneys' fees and expenses to the extent provided under applicable law."
            },
            {
                type: 'text',
                content: "14.6. Injunctive and Declaratory Relief. Except as provided in Section 14.3 above, the arbitrator shall determine all issues of liability on the merits of any claim asserted by either party and may award declaratory or injunctive relief only in favor of the individual party seeking relief and only to the extent necessary to provide relief warranted by that party's individual claim. The parties agree that litigations of any issues of public injunctive relief shall be stayed pending the outcome of the merits of any individual claims in arbitration."
            },
            {
                type: 'text',
                content: "14.7. Class Action Waiver. You and Moonbit Labs agree that each may bring claims against the other only in your or its individual capacity, and not as a plaintiff or class member in any purported class or representative proceeding. Further, if the parties' Dispute is resolved through arbitration, the arbitration may not consolidate another person's claims with your claims and may not otherwise preside over any form of a representative or class proceeding. If this specific provision is found to be unenforceable, the other sections of these Terms will still apply."
            },
            {
                type: 'text',
                content: "14.8. Severability. If an arbitrator or court with competent jurisdiction decides that any part of these Terms is invalid or unenforceable, the other parts will still apply."
            },
            {
                type: 'text',
                content: "Section 15. General Terms."
            },
            {
                type: 'text',
                content: "15.1. Reservation of Rights. Moonbit Labs and its licensors exclusively own all right, title, and interest to the Site, including all associated IP rights. You acknowledge that the Site is protected by copyright, trademark, and other laws of Mexico, International Treaties, the United States, and other jurisdictions. You agree not to remove, alter, copy, modify, or obscure any copyright, trademark, service mark or other IP rights, registered or registrable, notices incorporated in or accompanying the Site."
            },
            {
                type: 'text',
                content: "15.2. Entire Agreement. These Terms constitute the entire and exclusive understanding and agreement between Moonbit Labs and you regarding the Site, and these Terms supersede and replace all prior oral or written understandings or agreements between Moonbit Labs and you regarding the Site. If any provisions of these Terms are held invalid or unenforceable by a court of competent jurisdiction, that provision will be enforced to the maximum extent permissible, and the other provisions of these Terms shall remain in full force and effect. Except where provided by applicable law in your jurisdiction, you may not assign or transfer this Terms, by operation of laws or otherwise, without Moonbit Labs' prior written consent. Any attempt to assign or transfer these Terms absent of our consent or your statutory right, will be null. Moonbit Labs may freely assign or transfer these Terms without restriction. Subject to the foregoing, these Terms will bind and inure to the benefit of the parties, their successors and permitted assigns."
            },
            {
                type: 'text',
                content: "15.3. Notices. Any notices or other communications provided by Moonbit Labs under these Terms will be given by posting to the Site."
            },
            {
                type: 'text',
                content: "15.4. Waiver of Rights. Moonbit Labs' failure to enforce any right or provision of these Terms will not be considered a waiver of such right or provision. The waiver of any such right or provision will be effective only if in writing consent and signed by a duly authorized representative of Moonbit Labs. Except as expressly set forth in these Terms, the exercise by you or Moonbit Labs of any of its remedies under these Terms will be without prejudice to its other remedies under these Terms or otherwise."
            },
            {
                type: 'text',
                content: "Section 16. Contact Information. If you have any questions about these Terms or Site, please contact Moonbit Labs at hello@moonbitlabs.xyz."
            }
        ]
    },
    {
        title: 'Privacy Policy',
        body: [
            {
                type: 'text',
                content: "Last update: April 2022"
            },
            {
                type: 'text',
                content: "This Privacy Policy (“Privacy Policy”) is made to help you (“You”) understand how Moonbit Labs, S.A. de C.V. (“Moonbit Labs”, “We”, “Us” and “Our”) collects, uses, and shares your personal information as well as your exercise to your privacy rights."
            },
            {
                type: 'text',
                content: "Section 1. Scope. This Privacy Policy applies to personal information processed by Us, through our websites, mobile applications and any other services or interfaces owned or controlled by Moonbit Labs (each a “Service” and collectively “Services”). For the avoidance of doubt, Moonbit Labs does not control de blockchain protocol (“Protocol”) on which our Services, our fungible tokens and/or non-fungible tokens (“NFTs”) are tradable or usable and cannot control activity and data on the Protocol, the validation of transactions through the Protocol or the use of the Protocol."
            },
            {
                type: 'text',
                content: "Section 2. Changes to Our Privacy Policy. We may revise this Privacy Policy from time to time at Our sole discretion. If there are any material changes to this Privacy Policy, We will notify you as required by applicable law. You understand and agree that You will be deemed to have accepted the up-to-date Privacy Policy if you continue to use any of our Services, after any change is made to this Privacy Policy and takes effect."
            },
            {
                type: 'text',
                content: "Section 3. Personal Information We Collect. The categories of personal information we collect depends on how you interact with Moonbit Labs, our Services and the requirements of the applicable law. We collect information that you provide Us, information we obtain automatically when You use our Services, and information from other sources such as third-party services and organization, described below."
            },
            {
                type: 'text',
                content: "3.1. Information You Provide to Us Directly."
            },
            {
                type: 'text',
                content: "We may collect the following personal information that you provide to Us:"
            },
            {
                type: 'text',
                content: "3.1.1. Account Creation. We may collect information when you create an account whit Us or our Service providers, such as name and email address. We may also require You provide additional identity and verification information."
            },
            {
                type: 'text',
                content: "3.1.2. Purchases, Wallet and Transactions. To engage in certain transactions or purchases on the Services, you may need to provide Us or our third-party payment processors with your payment information and allow Us to connect to your digital wallet by providing us with your public wallet address. We will never ask you or collect your private keys. We do not directly collect or store any payment card information entered through Our Services or access your digital wallet, but We may receive from our third-party payment processing providers the information associated with your payment card (e.g. billing details)."
            },
            {
                type: 'text',
                content: "3.1.3. Other Transactions. We may collect personal information and details associated with your activities on our Services."
            },
            {
                type: 'text',
                content: "3.1.4. Your Communication With Us. We may collect personal information, such as email address, phone number or mailing address when you request information about our Services, register for our newsletter, apply for a job or otherwise communicate with us."
            },
            {
                type: 'text',
                content: "3.1.5. Interactive Features. We and others who use our Services may collect personal information that You submit or make available through our interactive features (e.g. through any of Moonbit Labs' social media, messaging chat features, and communities such as discord). Any personal information You provide on the public sections of these features will be considered “public” information (“User Content”), unless otherwise required by applicable law, and it will not be subject to the privacy protections referenced herein. Please be cautious before revealing publicly any information that may identify you in the real/tangible world to other users."
            },
            {
                type: 'text',
                content: "3.1.6. Surveys. We may contact You to participate in surveys. If You decide to participate, You may be asked to provide certain information which may include personal information."
            },
            {
                type: 'text',
                content: "3.1.7. Sweepstakes, Giveaways or Contests. We may collect personal information you provide for any sweepstakes, giveaways or contest that We may offer. In some jurisdictions We are required by law to publicly share information of sweepstakes or contests winners."
            },
            {
                type: 'text',
                content: "3.1.8. Conferences, Trade Shows and Other Events. We may collect personal information from You when Moonbit Labs and/or You attend or host any conference, trade shows, and any other event."
            },
            {
                type: 'text',
                content: "3.1.9. Business Development and Strategic Partnership. We may collect personal information from individuals and third-parties to assess and pursue potential business partnerships and/or opportunities."
            },
            {
                type: 'text',
                content: "3.2. Information Collected Automatically."
            },
            {
                type: 'text',
                content: "We may collect personal information automatically when you use our Services, such as:"
            },
            {
                type: 'text',
                content: "3.2.1. Automatic Data Collection. We may collect certain information automatically when You use our Services, such as your Internet protocol (IP) address, user settings, MAC address, cookie identifiers, mobile carrier and other unique identifiers, browser or device information, location information (including approximate location derived from IP address), Internet service provider, and metadata about the content You provide. We may also automatically collect information regarding your use of our Services, such as pages that You visit before, during and after using our Services, information about the links You click, the types of content You interact with, the frequency and duration of your activities, and other information about how you use our Services."
            },
            {
                type: 'text',
                content: "3.2.2. Cookie Policy for Cookies and Other Technologies. We, as well as third parties that provide content or other functionality on our Services, may use cookies, local storage, and other technologies (“Technologies”) to automatically collect information through your use of our Services."
            },
            {
                type: 'text',
                content: "3.2.3. Cookies. Cookies are small text files placed in device browsers that store preferences and facilitate ant enhance your experience."
            },
            {
                type: 'text',
                content: "Our uses of these Technologies fall into the following general categories:"
            },
            {
                type: 'text',
                content: "3.2.3.1. Operationally Necessary. This includes Technologies that allow You access to Our Services, applications, and tools that are required to identify irregular website behavior, prevent fraudulent activity, improve security, or allow You to make use of Our functionality."
            },
            {
                type: 'text',
                content: "3.2.3.2. Performance-Related. We may use Technologies to assess the performance of our Services, including as part of Our analytic practices to help Us understand how individuals use Our Services (see Analytics below)."
            },
            {
                type: 'text',
                content: "3.2.3.3. Functionality-Related. We may use Technologies that allow Us to offer You enhanced functionality when accessing or using Our Services. This may include identifying You when You sign into Our Services or keeping track of your specified preferences, interests, or past items viewed."
            },
            {
                type: 'text',
                content: "See “Your Privacy Choices and Rights” below to understand your choices regarding these Technologies."
            },
            {
                type: 'text',
                content: "3.2.3.4. Analytics. We may use Our Technologies and other third-party tools to process analytics information on Our Services. These Technologies allow Us to process usage data to better understand how Our Services are used, and to continually improve and personalize Our Services. Some of Our analytics partners include:"
            },
            {
                type: 'text',
                content: "Google Analytics. For more information about how Google uses your data and how to opt-out the use of your information (including for its own purposes, e.g. for profiling or linking to other data), please visit Google Analytics' Privacy Policy."
            },
            {
                type: 'text',
                content: "Social Media Platforms. Our Services may contain social media buttons, such as Twitter, Telegram, Discord, Instagram and Snapchat, which might include widgets such as the “share this” button or other interactive mini programs. These features may collect your IP address and which page You are visiting on Our Services and may set a cookie to enable the feature to function properly. Your interactions with these platforms are governed by the privacy policy of the company providing it, make sure you identify them."
            },
            {
                type: 'text',
                content: "3.3. Information Collected from Other Sources."
            },
            {
                type: 'text',
                content: "3.3.1. Third-Party Sources. We may obtain information about You from other sources, including through third-party services and organizations. For example, if You access Our Services through a third-party application, such as an app store or marketplace, a third-party login services, or a social networking site, We may collect information about You from those services that You have made available via your privacy settings."
            },
            {
                type: 'text',
                content: "3.3.2. Sharing Features. Our Services may offer various tools and functionalities that allow You to provide information about your friends; third parties may also use these services to upload information about You. Our Services may also allow You to forward or share certain content with a friend or colleague, such as an email invitation to use Our Services. Please only share with us contact information of people with whom you have a relationship (e.g. relatives, friends, neighbors, co-workers, partners, etc.)."
            },
            {
                type: 'text',
                content: "Section 4. How We Use Your Information. We use your information for a variety of business purposes, including to provide our Services, administrative purposes, and to market Our product and/or Services, as described below."
            },
            {
                type: 'text',
                content: "4.1. Provide Our Services. We use your information to fulfill Our contract with You and to provide Our Services and perform Our contract, such as:"
            },
            {
                type: 'text',
                content: "4.1.1. Managing your information;"
            },
            {
                type: 'text',
                content: "4.1.2. Providing access to certain areas, functionalities, and features of Our Services;"
            },
            {
                type: 'text',
                content: "4.1.3. Answering requests for customer, feedback or technical support;"
            },
            {
                type: 'text',
                content: "4.1.4. Communicating with You about your account, activities on Our Services, and policy or terms changes;"
            },
            {
                type: 'text',
                content: "4.1.5. Processing your financial information and other payment methods to facilitate purchases and transfers via the Services; and"
            },
            {
                type: 'text',
                content: "4.1.6. Allowing you to register for events."
            },
            {
                type: 'text',
                content: "4.2. Administrative Purposes. We use your information for Our legitimate interest, such as:"
            },
            {
                type: 'text',
                content: "4.2.1. Pursuing our legitimate interests such as direct marketing, research and development (including marketing research), network and information security, and fraud prevention;"
            },
            {
                type: 'text',
                content: "4.2.2. Detecting security incidents, protecting against malicious, deceptive, fraudulent or illegal activity, and prosecuting those responsible for those actions;"
            },
            {
                type: 'text',
                content: "4.2.3. Measuring interests and engagements in Our Services;"
            },
            {
                type: 'text',
                content: "4.2.4. Developing new products and Services;"
            },
            {
                type: 'text',
                content: "4.2.5. Ensuring internal quality control and safety;"
            },
            {
                type: 'text',
                content: "4.2.6. Debugging to identify and repair errors with Our Services;"
            },
            {
                type: 'text',
                content: "4.2.7. Authenticating and verifying individual identities;"
            },
            {
                type: 'text',
                content: "4.2.8. Auditing relating to interactions, transfers and other compliance activities;"
            },
            {
                type: 'text',
                content: "4.2.9. Sharing information with third parties as needed to provide the Services;"
            },
            {
                type: 'text',
                content: "4.2.10. Enforcing Our agreements and policies; and"
            },
            {
                type: 'text',
                content: "4.2.11. Other uses as required to comply with our legal obligations."
            },
            {
                type: 'text',
                content: "4.3. Marketing Our Products and Services. We may use personal information to tailor and provide You with content. We may provide these materials as permitted by applicable law. Some of the ways we may market to You include email campaigns."
            },
            {
                type: 'text',
                content: "If you have any questions about Our marketing practices or if You would like to opt out of the use of your personal information for marketing purposes, You may contact us at any time as set forth in “Contact Us” below."
            },
            {
                type: 'text',
                content: "4.4. With Your Consent. We may use personal information for other purposes that are clearly disclosed to You at the time you provide personal information or with your consent."
            },
            {
                type: 'text',
                content: "4.5. Other Purposes. We also use your information for other purposes as requested by You or as permitted by applicable law."
            },
            {
                type: 'text',
                content: "4.5.1. De-Identified and Aggregated Information. We may use personal information and other information about You to create de-identified and/or aggregated information, such as de-identified demographic information, de-identified location information, information about the device from which You access our Services, or other analyses We create."
            },
            {
                type: 'text',
                content: "Section 5. How We Disclose Your Information. We disclose your information to third parties for a variety of business purposes, including to provide Our Services, to protect Us or others, or in the event of a major business transaction such as a merger, sale, or asset transfer, as described below."
            },
            {
                type: 'text',
                content: "5.1. Disclosures to Provide Our Services. The categories of third parties with whom We may share your information are:"
            },
            {
                type: 'text',
                content: "5.1.1. Notice Regarding Use of Blockchain. Transactions involving any NFTs provided by Us will be conducted on the relevant Protocol. Information about your transfers and holdings will be provided to and by the Blockchain and may be accessible to third parties due to the public and transparent nature of the Protocol. As You should know, entries to the Blockchain are public, and because it may be possible for someone to identify You through your pseudonymous, public wallet address using external sources of information, any transaction You enter onto the Blockchain could possibly be used to identify You, or information about You."
            },
            {
                type: 'text',
                content: "5.1.2. Other Users of the Services and Parties You Transact With. Some of your personal information may be visible to other users of the Services (e.g., information featured on generally accessible parts of the contracts or on a user's profile). In addition, to complete transfers via the Services, We will need to share some of your personal information with the party that You are transacting with."
            },
            {
                type: 'text',
                content: "5.1.3. Third Party Websites and Applications. You may choose to share personal information or interact with third-party websites and/or third-party applications, including, but not limited to, third-party electronic wallet extensions. Once your personal information has been shared with a third-party's website or application, it will also be subject to such third party's privacy policy. We encourage You to closely read each of those parties' privacy policies before sharing any of your personal information or otherwise interacting with them. Please note that We do not control, and therefore, not responsible for the third-party's website or application processing your personal information."
            },
            {
                type: 'text',
                content: "5.1.4. Service Providers. We may share your personal information with our third-party service providers who use that information to help Us provide Our Services. This includes service providers that provide Us with IT support, hosting, customer services, and related services."
            },
            {
                type: 'text',
                content: "5.1.5. Business Partners. We may share your personal information with business partners to provide You with a product or service you have requested. We may also share your personal information to business partners with whom we jointly offer products or services."
            },
            {
                type: 'text',
                content: "5.1.6. Affiliates. We may share your personal information with members of our corporate family."
            },
            {
                type: 'text',
                content: "5.1.7. APIs/SDKs. We may use third-party application program interfaces (“APIs”) and software development kits (“SDKs”) as part of the functionality of Our Services. For more information about Our use of APIs and SDKs, please contact Us as set forth in “Contact Us” below."
            },
            {
                type: 'text',
                content: "5.2. Disclosures to Protect Us or Others. We may access, preserve, and disclose any information We store associated with You to external parties if We, in good faith, believe doing so is required or appropriate to: comply with law enforcement or national security requests and legal process, such as a court order or subpoena; protect your, Our, or others' rights, property, or safety; enforce Our policies, terms or contracts; collect amounts owed to Us; or assist with an investigation or prosecution of suspected or actual illegal activity."
            },
            {
                type: 'text',
                content: "5.3. Disclosure in the Event of Merger, Sale, or Other Asset Transfers. If We are involved in a merger, acquisition, financing due diligence, reorganization, bankruptcy, receivership, purchase or sales of assets, or transition of service to another provider, your information may be sold or transferred as part of such transaction, as permitted by law and/or contract."
            },
            {
                type: 'text',
                content: "Section 6. Your Privacy Choices and Rights. The privacy choices You may have about your personal information are determined by applicable law and are described below."
            },
            {
                type: 'text',
                content: "6.1. Email Communications. If You receive an unwanted email from Us, you can use the unsubscribe link found at the bottom of the email to opt-out of receiving future emails. Note that You will continue to receive transfer-related emails regarding Services you have requested. We may also send You certain non-promotional communications regarding Us and Our Services, and You will not be able to opt-out of those communications (e.g., communications regarding our Services or updates to Our Terms or this Privacy Policy)."
            },
            {
                type: 'text',
                content: "6.2. “Do Not Track”. Do Not Track (“DNT”) is a privacy preference that users can set in certain web browsers. Please note that We do not respond to or honor DNT signals or similar mechanisms transmitted by web browsers."
            },
            {
                type: 'text',
                content: "6.3. Cookies. You may stop or restrict the placement of Technologies on your device or remove them by adjusting your preferences as your browser or device permits. However, if You adjust your preferences, Our Services may not work properly. Please note that cookie-based opt-outs are not effective on mobile applications."
            },
            {
                type: 'text',
                content: "6.4. Your Privacy Rights. In accordance with applicable law, You may have the right to:"
            },
            {
                type: 'text',
                content: "6.4.1. Access Personal Information about You, including: (i) confirming whether We are processing your personal information; (ii) obtaining access to or a copy of your personal information; or (iii) receiving an electronic copy of personal information that You have provided to Us, or asking Us to send that information to another company (aka the Right of Data Portability);"
            },
            {
                type: 'text',
                content: "6.4.2. Request Correction of your personal information where it is inaccurate or incomplete. In some cases, We may provide self-service tools that enable You to update your personal information;"
            },
            {
                type: 'text',
                content: "6.4.3. Request Deletion of your personal information;"
            },
            {
                type: 'text',
                content: "6.4.4. Request Restriction of or Object to Our processing of your personal information, including where the processing of your personal information is based on our legitimate interest or for direct marketing purposes; and"
            },
            {
                type: 'text',
                content: "6.4.5. Withdraw Your Consent to Our processing of your personal information. Please note that your withdrawal will only take effect for the future processing and will not affect the lawfulness of processing before the withdrawal."
            },
            {
                type: 'text',
                content: "If You would like to exercise any of these rights, please contact Us as set forth in “Contact Us” below. We will process such requests in accordance with applicable laws."
            },
            {
                type: 'text',
                content: "Section 7. Security of Your Information. We take steps designed to ensure that your information is treated securely and in accordance with this Privacy Policy. Unfortunately, no system is 100% secure, and We cannot ensure or warrant the security of any information You provide to Us. To the fullest extent permitted by applicable law, We do not accept liability for unauthorized disclosure."
            },
            {
                type: 'text',
                content: "By using Our Services or providing personal information to Us, you agree that We may communicate with You electronically regarding security, privacy, and administrative issues relating to your use of Our Services. If We notice a security system's breach, We may attempt to notify You electronically by posting a notice on Our Services, by mail or by sending an email to You."
            },
            {
                type: 'text',
                content: "Section 8. International Data Transfers. All information processed by Us may be transferred, processed, and stored anywhere in the world, including, but not limited to, the United States, Mexico, or other countries, which may have data protection laws that are different from the laws where You live. We endeavor to safeguard your information consistent with the requirements of applicable laws."
            },
            {
                type: 'text',
                content: "Section 9. Retention of Personal Information. We store the personal information We collect as described in this Privacy Policy for as long as You use Our Services or as necessary to fulfill the purpose(s) for which it was collected, provide Our Services, resolve disputes, establish legal defenses, conduct audits, pursue legitimate business purposes, enforce Our agreements or contracts, and comply with applicable laws."
            },
            {
                type: 'text',
                content: "Section 10. Accessibility. This Privacy Policy uses industry-standard technologies and was developed in line with the World Wide Web Consortium's Web Content Accessibility Guidelines, version 2.1."
            },
            {
                type: 'text',
                content: "Section 11. Children's Information. The Services are not directed to children under 13 (or other age as required by local law), and We do not knowingly collect personal information form children. If you are a parent or guardian and believe your child has provided Us with personal information without your consent, You may contact Us as set forth in “Contact Us” below. If We learn that a child has provided Us with personal information in violation of applicable law, We will promptly take steps to delete such information, unless We have a legal obligation to not do so."
            },
            {
                type: 'text',
                content: "Section 12. Third-Party Websites/Applications. The Services may contain links to other websites/applications and other websites/applications may reference or link Our Services. These third-party services are not controlled by Us. We encourage You to read the privacy policies of each website and/or application with which You interact. We do not endorse, screen or approve, and are not responsible for, the privacy practices or content of such other websites and/or applications. Providing personal information to third-party websites and/or applications is at your own risk."
            },
            {
                type: 'text',
                content: "Section 13. Supervisory Authority. If You are located in the European Economic Area, Switzerland, or the United Kingdom, You have the right to lodge a complaint with a supervisory authority if You believe Our processing of your personal information violates applicable law."
            },
            {
                type: 'text',
                content: "Section 14. Contact Information. If you have any questions about our privacy practices or this Privacy Policy, or to exercise your rights as detailed in this Privacy Policy, please contact Moonbit Labs at hello@moonbitlabs.xyz."
            }
        ]
    },
];

module.exports = {
    iconMetadata
}